import { Condition, ConditionMode } from '@shared/models/structure';

/**
 * Finds an analog alarm condition by mode and operator direction.
 * Uses Mode + operator direction rather than array index because the tile editor
 * reorders the Conditions array on save, making index-based lookup unreliable.
 */
export function findAnalogCondition(
  conditions: Condition[],
  mode: ConditionMode,
  dir: 'high' | 'low'
): Condition | undefined {
  return conditions.find(c =>
    c.Mode === mode &&
    (dir === 'high' ? c.Comparison?.Operator?.includes('>') : c.Comparison?.Operator?.includes('<'))
  );
}
